import { WhatsAppOutlined } from '@ant-design/icons';
import { Button, Divider, FloatButton, Modal, Typography } from 'antd';
import { useState } from 'react';
import { resolveAssetUrl } from '../../../utils/resolveAssetUrl';
import IconLock from '../../Icons/Lock';
import IconProtect from '../../Icons/Protect';
import IconShield from '../../Icons/Shield';
import FooterDefault from '../../shared/FooterDefault';
import { useForm } from '../context';

const { Link } = Typography;

const Footer = () => {
  const { checkout } = useForm();
  const hasSomeContact = checkout?.companyEmail || checkout?.companyPhone;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [linkTerms, setLinkTerms] = useState('');

  const showModal = (param: string) => {
    setLinkTerms(param);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setLinkTerms('');
    setIsModalOpen(false);
  };

  return (
    <div>
      <Modal
        title={
          <div
            className="mt-8 flex rounded-lg items-center justify-center bg-gray-100 py-6"
            style={{ backgroundColor: checkout?.styleConfig?.footerBgColor }}
          >
            <img alt="Logo" className="max-w-100" src={resolveAssetUrl(checkout?.companyLogo)} />
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        style={{ minWidth: 320, maxWidth: 1200 }}
        width="100%"
        footer={[
          <Button className="rounded-md w-20" type="default" onClick={() => setIsModalOpen(false)}>
            OK
          </Button>,
        ]}
      >
        {checkout?.agreementTerms && checkout?.agreementTerms.type === 'text' ? (
          <span dangerouslySetInnerHTML={{ __html: checkout?.agreementTerms?.value }} />
        ) : (
          <iframe
            className="w-full"
            style={{
              height: '60vh',
              border: 'none',
            }}
            src={resolveAssetUrl(linkTerms)}
          />
        )}
      </Modal>

      <div className="mt-2 flex flex-col sm:flex-row justify-center gap-5">
        <div className="flex items-center justify-center gap-1 text-green-600">
          <IconLock className="w-4.5" />
          <p className="text-sm">Privacidade protegida</p>
        </div>

        <div className="flex items-center justify-center gap-1 text-green-600">
          <IconShield className="w-4.5" />
          <p className="text-sm">Compra 100% segura</p>
        </div>

        <div className="flex items-center justify-center gap-1 text-green-600">
          <IconProtect className="w-4.5" />
          <p className="text-sm">Verificado e protegido</p>
        </div>
      </div>

      {hasSomeContact && (
        <div>
          <Divider variant='dashed' />
          <p className="text-base text-black">Precisa de ajuda?</p>
        </div>
      )}

      {checkout?.companyEmail && (
        <div>
          <p className="text-sm text-gray-600">
            Dúvidas sobre o produto: <span className="font-medium">{checkout?.companyEmail}</span>
          </p>
        </div>
      )}

      {checkout?.companyPhone && (
        <>
          <div>
            <Link
              className="text-sm"
              href={`https://api.whatsapp.com/send?phone=${checkout?.companyPhone}`}
              target="_blank"
            >
              Preciso de ajuda para preencher esta tela
            </Link>
          </div>

          <FloatButton
            tooltip="Como posso ajudar?"
            type="primary"
            href={`https://api.whatsapp.com/send?phone=${checkout?.companyPhone}`}
            target="_blank"
            icon={<WhatsAppOutlined />}
          />
        </>
      )}

      <Divider variant='dashed' className="my-6" />

      {!!checkout?.installmentFee && checkout?.installmentFee > 0 && (
        <div>
          <p className="text-xs text-gray-500 leading-relaxed">
            * O valor parcelado possui acréscimo de {checkout?.installmentFee / 100}% a.m.
          </p>
        </div>
      )}

      {checkout?.agreementTerms ? (
        <div className="text-xs text-gray-500 leading-relaxed">
          Ao clicar em "Comprar Agora", eu declaro que li e concordo com os
          <Link
            className="text-xs ml-1"
            onClick={() =>
              showModal(checkout?.agreementTerms?.type == 'text' ? '' : (checkout?.agreementTerms?.value as string))
            }
          >
            Termos de Uso, Política de Privacidade e Cookies{' '}
          </Link>
          e afirma que é maior de idade ou autorizado e acompanhado por um responsável legal.
        </div>
      ) : (
        <div className="text-xs text-gray-500 leading-relaxed">
          Ao clicar em "Comprar Agora", eu declaro que li e concordo com o
          <Link className="text-xs ml-1" onClick={() => showModal('https://routerfy.com/termosuso')}>
            Termos de Uso
          </Link>
          ,
          <Link className="text-xs ml-1" onClick={() => showModal('https://routerfy.com/politicaprivacidade')}>
            Política de Privacidade
          </Link>{' '}
          e
          <Link className="text-xs ml-1" onClick={() => showModal('https://routerfy.com/politicacookies')}>
            Cookies{' '}
          </Link>
          e afirma que é maior de idade ou autorizado e acompanhado por um responsável legal.
        </div>
      )}

      <FooterDefault className='mt-4' logo={checkout?.companyLogo} bgColor={checkout?.styleConfig?.footerBgColor} />
    </div>
  );
};

export default Footer;
